import { AlertCircle } from 'lucide-react';
import { ConversationEscalatedEvent as ConversationEscalatedEventType } from '../types';
import EventShell from './EventShell';
import { assignedViaLabel, escalatedByLabel } from '../../agents/escalations';

interface Props {
  event: ConversationEscalatedEventType;
}

export default function ConversationEscalatedEvent({ event }: Props) {
  const rep = event.payload.target_user_name || event.payload.target_user_email;
  const routing = [event.payload.skill_name, assignedViaLabel(event.payload.assigned_via)]
    .filter(Boolean)
    .join(' · ');
  return (
    <EventShell
      color="purple"
      icon={<AlertCircle className="w-3.5 h-3.5" />}
      title={rep ? `Conversation Escalated to ${rep}` : 'Conversation Escalated'}
      timestamp={event.created_at}
    >
      <p>{event.payload.reason}</p>
      {routing && <p>{routing}</p>}
      {event.payload.escalated_by && <p>By: {escalatedByLabel(event.payload.escalated_by)}</p>}
    </EventShell>
  );
}
